import { Input } from '@heroui/react';
import { Search } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';

type FilterOption = { value: string; label: string };

export const filterOptionsByLabel = <T extends FilterOption>(
  options: T[],
  searchTerm: string
) => {
  const term = searchTerm.trim().toLowerCase();
  return term
    ? options.filter(option => option.label.toLowerCase().includes(term))
    : options;
};

type FilterSelectSearchProps = {
  isVisible: boolean;
  value: string;
  onChange: (value: string) => void;
  /** Test id of the filter; the search box gets it with a `-search` suffix. */
  filterTestId?: string;
};

/** Search box shown above a filter's options; renders nothing when not visible. */
export function FilterSelectSearch({
  isVisible,
  value,
  onChange,
  filterTestId
}: Readonly<FilterSelectSearchProps>) {
  if (!isVisible) return null;

  return (
    <div className='pb-1 pr-1.5 pt-2'>
      <Input
        value={value}
        onValueChange={onChange}
        placeholder={i18n.t('label.search')}
        aria-label={i18n.t('label.search')}
        startContent={<Search className='h-4 w-4 text-on-surface-variant' />}
        size='sm'
        variant='bordered'
        classNames={{
          input: 'text-body-sm',
          inputWrapper:
            'rounded-md border-[0.5px] border-solid border-outline bg-surface px-2'
        }}
        data-testid={filterTestId ? `${filterTestId}-search` : undefined}
      />
    </div>
  );
}
